import axios from "axios";
import {setIsValidOutsideReact} from "../contexts/AuthContext";


const getBaseURL = () => {
    const frontendUrl = process.env.REACT_APP_FRONTEND_URL;

    if (frontendUrl && frontendUrl.includes('localhost')) {
        return process.env.REACT_APP_BACKEND_URL 
            ? `${process.env.REACT_APP_BACKEND_URL}/api/v1/`
            : 'http://localhost:3001/api/v1/';
    }

    return '/api/v1/';
};


const api = axios.create({
    withCredentials: true,
    baseURL: getBaseURL(),
});


api.interceptors.response.use(
    (response) => {
        return response;
    },
    async (error) => {
        const status = error?.response?.status;

        if (status === 419) {
            localStorage.removeItem("session_expires")
            setIsValidOutsideReact(false);
        }
        return Promise.reject(error);
    }
);


export default api;